<template>
  <div class="MyTable">
    <div class="table fs18">
      <div class="title">
        <div class="item" v-for="t in titles">{{t}}</div>
      </div>
      <div class="row" v-for="(info, index) in infos" :class="{even: index % 2, gold: heroLength >0 && index < heroLength && isRank, grey: ((typeof info[2]) !=='number' && ((typeof info[3]) !=='number' || info[3] < -2000))&&isRank}">
        <div class="item"  v-for="i in info">{{i}}</div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'MyTable',
   props: ['titles', 'infos', 'isRank', 'rankLength'],
   computed: {
     heroLength () {
       return this.rankLength || (0.05 * this.infos.length).toFixed(0)
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyTable{
   display: flex;
   align-items: center;
   justify-content: center;
 }
 .table{
   /* width: 62.5vw; */
   border: 2px solid #3B4ADD;
   background-color: white;
 }
 .title{
   display: flex;
   background: linear-gradient(90deg, #3b4add, #5e29ed);
   color: white;
   height: 4.0625vw;
 }
 .row{
   display: flex;
   height:3.4375vw;
 }
 .item{
   display: flex;
   width: 12.5vw;
   align-items: center;
   justify-content: center;
 }
 .even{
   background-color: #f7fbfe;
 }
 .gold {
   background-color: #F7D94C;
   box-shadow: 0 0 5px 4px #F7D94C;
 }
 .even.gold{
   background-color: #FFC408;
   box-shadow: 0 0 5px 4px #FFc408;
 }
 .grey{
   background-color: #eee;
   color: rgba(60,60,60, 0.7);
 }
 .even.grey{
   background-color: #bbb;
   color: rgba(60,60,60, 0.7);
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .title{
     height: 8vw;
     font-size: 12px;
   }
   .row{
     height: 6.8vw;
     width: 90vw;
   }
   .item{
     font-size: 12px;
     width: 22.5vw;
     flex-grow: 1;
     height: 6.8vw;
   white-space: nowrap;
   }
 }
</style>
